 const MAIN_MENU = [
  {
    title: 'Dashboard',
    path: '/',
    icon:'dashboard',
    roles: ['SUPERADMIN'],
  },
  {
    title: 'Gestion des instituts',
    path: '/instituts',
    icon:'shop',
    roles: ['ADMIN','MANAGER','SUPERADMIN'],
  },
  {
    title: 'Gestion des prestations',
    path: '/prestations',
    icon:'hairdresser',
    roles: ['ADMIN','MANAGER','SUPERADMIN'],
  },
  {
    title: 'Gestion des praticiennes',
    path: '/praticienne',
    icon:'dye',
    roles: ['ADMIN','MANAGER','SUPERADMIN'],
  },
  {
    title: 'Gestion d\'envie du moment',
    path: '/enviemoment',
    icon:'envie-moments',
    roles: ['ADMIN', 'SUPERADMIN'],
  },
  {
    title: 'Planification',
    path: '/planification',
    icon:'plannification',
    roles: ['ADMIN', 'MANAGER', 'EMPLOYE', 'SUPERADMIN'],
  },
  {
    title: 'Gestion des utilisateurs',
    path: '/users',
    icon:'group-profile-users',
    roles: ['ADMIN', 'MANAGER', 'SUPERADMIN'],
  },
  {
    title: 'Gestion des bon plan',
    path: '/bon-plans',
    icon:'bon-plans',
    roles: ['ADMIN', 'SUPERADMIN'],
  },
  {
    title: 'Gestion des clients',
    path: '/clients',
    icon:'g-clients',
    roles: ['ADMIN', 'MANAGER', 'SUPERADMIN', 'EMPLOYE'],
  },
  {
    title: 'Historique des rdvs',
    path: '/historique',
    icon:'historic',
    roles: ['ADMIN', 'MANAGER', 'SUPERADMIN'],
  },
  {
    title: 'Paramètres supplémentaires',
    path: '/config',
    icon:'settings',
    roles: ['ADMIN', 'MANAGER', 'SUPERADMIN'],
   },
   {
     title: 'Historique des points',
     path: '/points',
     roles: ['ADMIN', 'MANAGER', 'SUPERADMIN','EMPLOYE'],
     hidden: true
   },
  {
    title: 'Marques',
    path: '/marques',
    icon:'price-tags',
    roles: ['ADMIN', 'SUPERADMIN'],
  },
   {
     title: 'Gestion des produits',
     path: '/products',
     icon:'cart',
     roles: ['ADMIN', 'SUPERADMIN', 'MARQUE'],
   },
   {
     title: 'Validation des drafts',
     path: '/products-drafts',
     icon:'cart',
     roles: ['ADMIN', 'SUPERADMIN'],
   },
   {
     title: 'Salons',
     path: '/salons',
     icon:'insert-template',
     roles: ['ADMIN', 'SUPERADMIN'],
   },
   {
     title: 'Panneau',
     path: '/panneau',
     icon:'images',
     roles: ['ADMIN', 'SUPERADMIN'],
   },
   {
     title: 'Gestion des livraisons',
     path: '/livraisons',
     icon:'images',
     roles: ['MARQUE'],
   },
   {
     title: 'Gestion des livraisons',
     path: '/livraisons',
     icon:'images',
     roles: ['MARQUE'],
   },
   {
     title: 'Gestion des commandes',
     path: '/commandes',
     icon:'images',
     roles: ['MARQUE','ADMIN', 'SUPERADMIN'],
   },
   {
     title: 'Gestion des retours',
     path: '/retours',
     icon:'images',
     roles: ['MARQUE','ADMIN', 'SUPERADMIN'],
   },
   {
     title: 'Messagerie',
     path: '/messagerie',
     icon:'images',
     roles: ['MARQUE','ADMIN', 'SUPERADMIN'],
   },
   {
     title: 'Coupons',
     path: '/coupons',
     icon:'images',
     roles: ['MARQUE','ADMIN', 'SUPERADMIN'],
   },
  //  {
  //   title: 'Gestion coupons',
  //   path: '/coupons',
  //   icon:'shop',
  //   roles: ['ADMIN','MANAGER','SUPERADMIN'],
  // },
];
const cached_list = process.env.CACHER_MENU.split(',');
export const MENU = MAIN_MENU.filter((elm) => !cached_list.includes(elm.path));
